import React from 'react';

/**
 * Page-level heading block — matches the design's `.page-head` recipe.
 *
 *   `hello`    — small primary-colored greeting line above the title
 *                ("Welcome back, Maria")
 *   `title`    — 32px / 600 / -0.02em / fg
 *   `subtitle` — 14px / fg-muted, max 560px (constrained for readability)
 *   `actions`  — slot on the right for buttons
 *
 * Named distinctly from existing top-nav `PageHeader` to avoid collision.
 */
export default function PageHeading({
  hello,
  title,
  subtitle,
  actions,
  className = '',
}) {
  return (
    <div
      className={`flex flex-wrap items-end justify-between gap-6 mb-4 ${className}`}
    >
      <div className="min-w-0 flex-1">
        {hello ? (
          <div className="text-[13px] font-semibold leading-4 text-primary tracking-[0.02em] mb-1">
            {hello}
          </div>
        ) : null}
        <h1 className="text-[24px] leading-[1.15] font-semibold text-fg tracking-[-0.02em] m-0">
          {title}
        </h1>
        {subtitle ? (
          <p className="mt-1 text-sm text-fg-muted max-w-[560px]">
            {subtitle}
          </p>
        ) : null}
      </div>
      {actions ? (
        <div className="shrink-0 flex items-center gap-2">{actions}</div>
      ) : null}
    </div>
  );
}
